import { Badge } from "@jhool-io/fe-components";
import { ProviderCredential } from "../../clients/types/clients.types";

export const getProviderCredenetialPillStyle = (
    credential: ProviderCredential
) => {
    let bgColor: string;
    let textColor: string;

    switch (credential) {
        case ProviderCredential.LMSW:
        case ProviderCredential.MHCLP:
            textColor = "var(--color-warning-text)";
            bgColor = "var(--color-warning-bg)";
            break;
        case ProviderCredential.LMSWA:
        case ProviderCredential.LMHCA:
        case ProviderCredential.PSYDA:
        case ProviderCredential.PHDA:
        case ProviderCredential.LCSWA:
            textColor = "var(--color-success-text)";
            bgColor = "var(--color-success-bg)";
            break;
        case ProviderCredential.LMHCB:
        case ProviderCredential.PSYDB:
        case ProviderCredential.PHDB:
        case ProviderCredential.LCSWB:
            textColor = "var(--color-danger-text)";
            bgColor = "var(--color-danger-bg)";
            break;
        case ProviderCredential.LMHCC:
        case ProviderCredential.PSYDC:
        case ProviderCredential.PHDC:
        case ProviderCredential.LCSWC:
            textColor = "var(--color-neutral-text)";
            bgColor = "var(--color-neutral-bg)";
            break;
        default:
            textColor = "var(--color-success-text)";
            bgColor = "var(--color-success-bg)";
            break;
    }

    return (
        <Badge
            content={credential}
            type="custom"
            textColor={textColor}
            bgColor={bgColor}
        />
    );
};
